const styleVariables = () => {
  return {
    colors: {
      primary: '#2e3348',
      secondary: '#5f9f7c',
      accent: '#673320',
      positive: '#84b65b',
      warning: '#E98300',
      bg: 'rgba(245,245,245, .85)',
      gray1: '#F4F4F4',
      gray2: '#E8E8E8',
      gray3: '#CBCBCB',
      gray4: '#9B9B9B',
      gray5: '#5A5A5A',
      links: {
        default: '#5f9f7c',
        hover: '#673320',
      },
      border: '#2e3348',
      header: '#003F6A',
      footer: '#003F6A',
    },
    boxShadow: '0 2px 10px 1px rgba(0,0,0, .1)',
    fonts: {
      heading: 'Lato',
      body: 'Merriweather, serif',
    }
  }
}

export default styleVariables
